module.exports = __webpack_public_path__ + "static/media/liri.c427f3a6.gif";